import { render, staticRenderFns } from "./TaskWasReAssigned.vue?vue&type=template&id=fc4131cc"
import script from "./TaskWasReAssigned.vue?vue&type=script&lang=js"
export * from "./TaskWasReAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports